<div class="markdown">
  <markdown
    [data]="changelog$ | async"
  >
  </markdown>
</div>
